import "../../../../styles/productView.scss";

import Icon, {iconColor, iconTypes} from "../../../common/components/Icon.jsx";
import { Tag, tagTypes } from "../../../common/components/Tag.jsx";

import Loading from "../../../common/components/Loading.jsx";
import {Localization} from "../../../common/util/localization.jsx";
import Modal from "../../../common/components/Modal.jsx";
import PropTypes from "prop-types";
import React from "react";
import ResponsiveColumn from "../../../common/components/ResponsiveColumn";
import ResponsiveRows from "../../../common/components/ResponsiveRows";
import Scroll from "../../../common/components/Scroll";
import { connect } from "react-redux";
import { countOrderLines } from "../../util/orderUtil";
import { withRouter } from "react-router-dom";

const mapStateToProps = () => {
    return (state) => ({
        activeOrder: state.order.active,
    });
};

// Line item in details modal popup
class ShoppingCartDetailsListItem extends React.PureComponent {
    constructor(props){
        super(props);
    }

    render(){
        const {
            line,
        } = this.props;


        const hasDiscount =  line.product.campaignDiscount ? true : false;  
        const hasInvoiceGroup =  line.product.invoiceGroup ? true : false;  
         
        const netpriceExDiscount = hasDiscount ? line.product.priceExCampaignDiscount : null;
        const discountText = hasDiscount ? `${line.product.campaignDiscount}%` : "";
        const pending = line.reservationPending ? "venter..." : line.reservedQty;

        return (
            <div className="grid-row middle">
                <div className="grid-col" style={{flex: "1"}}>{line.product.epdNo}</div>
                <div className="grid-col" style={{flex: "2"}}>{line.product.productName}</div>
                <div className="grid-col" style={{flex: "2"}}>{line.product.category}</div>
                <div className="grid-col" style={{flex: "1.5"}}>{line.product.supplierName}</div>
                { hasInvoiceGroup && (
                    <div className="grid-col" style={{flex: "2"}}>{line.product.invoiceGroup}</div>
                )}
                <div className="grid-col crossed" style={{flex: "1"}}>{netpriceExDiscount}</div>
                <div className={`grid-col ${hasDiscount ? "discount" : ""}`} style={{flex: "1"}}>{line.product.price}</div>
                <div className="grid-col" style={{flex: "0.5"}}>{discountText}</div>
                <div className="grid-col" style={{flex: "0.5"}}>{line.orderedQty}</div>
                <div className={`grid-col ${line.reservationPending ? "reservationPending" : ""}`} style={{flex: "0.5"}}>{pending} </div>
                <div className="grid-col" style={{flex: "1"}}>{line.netSum}</div>
            </div>
        );
    }
}

ShoppingCartDetailsListItem.propTypes = {
    localization: Localization.propTypes.isRequired,
    line: PropTypes.object.isRequired,
};


// Component for displaying the current shopping cart.
// Shoppingcart can be viewed but not altered.
class ShoppingCartDetailsModal extends React.PureComponent {
    constructor(props){
        super(props);

        this.sortProductName = this.sortProductName.bind(this);
        this.sortEpdNo = this.sortEpdNo.bind(this);
        this.sortProductGroup = this.sortProductGroup.bind(this);
        this.sortSupplier = this.sortSupplier.bind(this);
        this.getConfirmedLines = this.getConfirmedLines.bind(this);
        this.onClickShowPdf = this.onClickShowPdf.bind(this);

        this.prepareLines = this.prepareLines.bind(this);
        this.getInitialSortState = this.getInitialSortState.bind(this);
        this.state =  this.getInitialSortState();
    }

    componentDidMount() {
        const {
            activeOrder,
            setActiveOrder,
        } = this.props;

        (async () => {
            await setActiveOrder(activeOrder.shipmentId, activeOrder.distributionRouteId, activeOrder.deliveryDate, true);
            // eslint-disable-next-line react/no-did-mount-set-state
            //this.setState({sortedLines : activeOrder.orderLines});
        })();
    }

    getInitialSortState()
    {
        return { 
            sortDescendingName: false, sortAscendingName : false, 
            sortDescendingEpdNo: false, sortAscendingEpdNo: false, 
            sortAscendingGroup: false, sortDescendingGroup: false, 
            sortDescendingSupplier: false, sortAscendingSupplier : false,
            sortedLines: [],
        };
    }

    sortProductName()
    {       
        // reverse the sort order
        const ascending =  this.state.sortDescendingName || !this.state.sortAscendingName;
        const descending =  !ascending;
       
        const initialState =  this.getInitialSortState();
        this.setState( { ...initialState, sortDescendingName: descending, sortAscendingName : ascending });

        const confirmedLines = this.getConfirmedLines();
        let sortedLines = confirmedLines ? confirmedLines : [];
        sortedLines = [...sortedLines].sort((a, b) => ascending ? a.product.productName.localeCompare(b.product.productName) : b.product.productName.localeCompare(a.product.productName));
        this.setState({sortedLines : sortedLines});
    }

    sortEpdNo()
    {       
        const {
            activeOrder,
        } = this.props;

        // reverse the sort order
        const ascending =  this.state.sortDescendingEpdNo || !this.state.sortAscendingEpdNo;
        const descending =  !ascending;
       
        const initialState =  this.getInitialSortState();
        this.setState( { ...initialState, sortDescendingEpdNo: descending, sortAscendingEpdNo : ascending });

        let sortedLines =  activeOrder.orderLines ? activeOrder.orderLines : [];
        sortedLines = [...sortedLines].sort((a, b) => ascending ? a.product.epdNo.localeCompare(b.product.epdNo) : b.product.epdNo.localeCompare(a.product.epdNo));
        this.setState({sortedLines : sortedLines});
    }

    sortProductGroup()
    {       
        const {
            activeOrder,
        } = this.props;

        // reverse the sort order
        const ascending =  this.state.sortDescendingGroup|| !this.state.sortAscendingGroup;
        const descending =  !ascending;
       
        const initialState =  this.getInitialSortState();
        this.setState( { ...initialState, sortDescendingGroup: descending, sortAscendingGroup : ascending });

        let sortedLines =  activeOrder.orderLines ? activeOrder.orderLines : [];
        sortedLines = [...sortedLines].sort((a, b) => ascending ? a.product.category.localeCompare(b.product.category) : b.product.category.localeCompare(a.product.category));
        this.setState({sortedLines : sortedLines});
    }

    sortSupplier()
    {       
        const {
            activeOrder,
        } = this.props;

        // reverse the sort order
        const ascending =  this.state.sortDescendingSupplier || !this.state.sortAscendingSupplier;
        const descending =  !ascending;
       
        const initialState =  this.getInitialSortState();
        this.setState( { ...initialState, sortDescendingSupplier: descending, sortAscendingSupplier : ascending });

        let sortedLines =  activeOrder.orderLines ? activeOrder.orderLines : [];
        sortedLines = [...sortedLines].sort((a, b) => ascending ? a.product.epdNo.localeCompare(b.product.epdNo) : b.product.epdNo.localeCompare(a.product.epdNo));
        this.setState({sortedLines : sortedLines});
    }

    onClickShowPdf() {
        const {
            activeOrder,
            showShoppingCartPdf,
            token,
        } = this.props;

        const data = {
            shipmentId: activeOrder.shipmentId,
            distributionRouteId: activeOrder.distributionRouteId,
            deliveryDate: activeOrder.deliveryDate,
        };

        showShoppingCartPdf(data, token);
    }

    getConfirmedLines() {
        const {
            activeOrder,
        } = this.props;
        const confirmedLines = activeOrder.orderLines && activeOrder.orderLines.filter( (line) => line.warningText==null && line.errorText==null && !(activeOrder.unConfirmedOrderLines && activeOrder.unConfirmedOrderLines.find( (item) => item.product.productId===line.productId ) || false));        
        return confirmedLines;
    }

    prepareLines() {
        const {
            localization,
            activeOrder,
        } = this.props;

        const retNodes = [];

        const createListItem = (keyStart, line, index) => (
            <ShoppingCartDetailsListItem
                key={`${keyStart}-${line.productId}-${index}`}
                localization={localization}
                line={line || {}}
                list={activeOrder}
            />
        );

        //filter out all with warnings/errors
        const storageQtyLines = (activeOrder.unConfirmedOrderLines && activeOrder.unConfirmedOrderLines.filter( (line) => line.lowQtyForStorageTypes!=="" ) || [])
            .concat( activeOrder.orderLines && activeOrder.orderLines.filter( (line) => line.lowQtyForStorageTypes!=="" ) || [] );

        const unConfirmedLines = activeOrder.unConfirmedOrderLines && activeOrder.unConfirmedOrderLines.filter( (line) => line.warningText==null && line.errorText==null && line.lowQtyForStorageTypes==="") || [];
        if( (unConfirmedLines.length > 0 || storageQtyLines.length > 0)) {
            const storageText = storageQtyLines.length>0 ? `${localization.text("order","lowQtyStorageTypeTag")} ${storageQtyLines[0].lowQtyForStorageTypes}` : "";
            const unconfirmedText = unConfirmedLines.length>0 ? `${localization.text("order","unconfirmed")}${storageQtyLines.length>0 ? " / ": ""}` : "";
            retNodes.push(<div className="shopping-cart-list-splitter-ordered" key={"unconfirmed"} ><Tag type={tagTypes.red} label={unconfirmedText + storageText} /></div>);            
            if(unConfirmedLines.length > 0)  retNodes.push(...unConfirmedLines.map( (line, index) => createListItem("Un", line, index) ));
            if(storageQtyLines.length > 0) retNodes.push(...storageQtyLines.map( (line, index) => createListItem("Un", line, index) ));
        }

        //list all with warnings
        const warningLines = (activeOrder.unConfirmedOrderLines && activeOrder.unConfirmedOrderLines.filter( (line) => line.warningText!=null && line.errorText==null &&  line.lowQtyForStorageTypes==="" ) || [])
            .concat( activeOrder.orderLines && activeOrder.orderLines.filter( (line) => line.warningText!=null && line.errorText==null &&  line.lowQtyForStorageTypes==="" ) || [] );
        if( warningLines.length>0 ){
            retNodes.push(<div className="shopping-cart-list-splitter-ordered" key={"warnings"} ><Tag type={tagTypes.red} label={localization.text("order","warningTag")} /></div>);
            retNodes.push(...warningLines.map( (line, index) => createListItem("Wa", line, index) ));
        }

        //list all with errors
        const errorLines = (activeOrder.unConfirmedOrderLines && activeOrder.unConfirmedOrderLines.filter( (line) => line.errorText!=null ) || [])
            .concat( activeOrder.orderLines && activeOrder.orderLines.filter( (line) => line.errorText!=null ) || [] );
        if( errorLines.length>0 ){
            retNodes.push(<div className="shopping-cart-list-splitter-ordered" key={"errors"} ><Tag type={tagTypes.red} label={localization.text("order","errorTag")} /></div>);
            retNodes.push(...errorLines.map( (line, index) => createListItem("Er", line, index) ));
        }

        //We want to filter out all lines that appears in unordered, or have error or warning message
        //const confirmedLines = activeOrder.orderLines && this.state.sortedLines.filter( (line) => line.warningText==null && line.errorText==null && !(activeOrder.unConfirmedOrderLines && activeOrder.unConfirmedOrderLines.find( (item) => item.product.productId===line.productId ) || false));
        const confirmedLines = this.state.sortedLines.length > 0 ? this.state.sortedLines : this.getConfirmedLines();       
        if( confirmedLines ){
            retNodes.push(<div className="shopping-cart-list-splitter-ordered" key={"ordered"} ><Tag type={tagTypes.green} label={localization.text("order","ordered")} /></div>);
            retNodes.push(...confirmedLines.map( (line, index) => createListItem("Or", line, index) ));
        }

        return retNodes;
    }

    render(){
        const {
            localization,
            activeOrder,
            onCloseModal,
            hasWarningLines,
            hasErrorLines,
        } = this.props;

        const orderFeeOrDiscount = activeOrder.orderFee || activeOrder.orderDiscount || 0;
        const totalCost = activeOrder.sumExVat || 0;
        const baseAmountOrderFee = activeOrder.baseAmountOrderFee || 0;
        const orderSize = countOrderLines(activeOrder);
        const hasInvoiceGroups =   (activeOrder.unConfirmedOrderLines && activeOrder.unConfirmedOrderLines.some(l => l.invoiceGroup!=null ))
                                || (activeOrder.orderLines && activeOrder.orderLines.some(l => l.invoiceGroup!=null));

        return (
            <Modal onCloseModal={onCloseModal}>
                <div className="modal-wrapper" style={{width:1375}}>
                    <div className="header" style={{height:40}}>
                        <div className="header-left">
                            <div className="header-detail">{localization.text("order","shoppingCartModal","header")}</div>
                        </div>
                        <button className="btn circular" style={{float:"right"}} onClick={onCloseModal}>
                            <Icon type={iconTypes.x} color={iconColor.red}/>
                        </button>
                        <button className="btn circular" style={{marginTop:"0px", marginLeft:"10px", marginRight:"10px", float:"right" }} onClick={this.onClickShowPdf}>
                            <Icon type={iconTypes.print}></Icon>
                        </button>
                    </div>
                    <div className="body bottom-border" style={{width:"100%"}}>
                        <div className="gebyr-grid">
                            <div className="grid-header">
                                <div className="header-col" style={{flex: "1"}}>
                                    <button  className="btn-sort" onClick={this.sortEpdNo}>
                                        {!this.state.sortAscendingEpdNo && !this.state.sortDescendingEpdNo &&  (<Icon type={iconTypes.arrowUpDown} />)}
                                        {this.state.sortAscendingEpdNo && (<Icon type={iconTypes.arrowUp} />)}
                                        {this.state.sortDescendingEpdNo && (<Icon type={iconTypes.arrowDown} />)}
                                        {localization.text("order","shoppingCartModal","epdNo")}
                                    </button>
                                </div>
                                <div className="header-col" style={{flex: "2"}}>
                                    <button  className="btn-sort" onClick={this.sortProductName}>
                                        {!this.state.sortAscendingName && !this.state.sortDescendingName &&  (<Icon type={iconTypes.arrowUpDown} />)}
                                        {this.state.sortAscendingName && (<Icon type={iconTypes.arrowUp} />)}
                                        {this.state.sortDescendingName && (<Icon type={iconTypes.arrowDown} />)}
                                        {localization.text("order","shoppingCartModal","productName")}
                                    </button>
                                </div>
                                <div className="header-col" style={{flex: "2"}}>
                                    <button  className="btn-sort" onClick={this.sortProductGroup}>
                                        {!this.state.sortAscendingGroup && !this.state.sortDescendingGroup &&  (<Icon type={iconTypes.arrowUpDown} />)}
                                        {this.state.sortAscendingGroup && (<Icon type={iconTypes.arrowUp} />)}
                                        {this.state.sortDescendingGroup && (<Icon type={iconTypes.arrowDown} />)}
                                        {localization.text("order","shoppingCartModal","category")}
                                    </button>
                                   
                                </div>
                                <div className="header-col" style={{flex: "1.5"}}>
                                    <button  className="btn-sort" onClick={this.sortSupplier}>
                                        {!this.state.sortAscendingSupplier && !this.state.sortDescendingSupplier &&  (<Icon type={iconTypes.arrowUpDown} />)}
                                        {this.state.sortAscendingSupplier && (<Icon type={iconTypes.arrowUp} />)}
                                        {this.state.sortDescendingSupplier && (<Icon type={iconTypes.arrowDown} />)}
                                        {localization.text("order","shoppingCartModal","supplierName")}
                                    </button>
                                </div>
                                { hasInvoiceGroups && (
                                    <div className="header-col" style={{flex: "1"}}>
                                        {localization.text("order","shoppingCartModal","invoicegroup")}
                                    </div>
                                )}
                                <div className="header-col" style={{flex: "1"}}>
                                    {localization.text("order","shoppingCartModal","priceNormal")}
                                </div>
                                <div className="header-col" style={{flex: "1"}}>
                                    {localization.text("order","shoppingCartModal","pricePerPackage")}
                                </div>
                                <div className="header-col" style={{flex: "0.5"}}>
                                    {localization.text("order","shoppingCartModal","discount")}
                                </div>
                                <div className="header-col" style={{flex: "0.5"}}>
                                    {localization.text("order","shoppingCartModal","orderedQty")}
                                </div>
                                <div className="header-col" style={{flex: "0.5"}}>
                                    {localization.text("order","shoppingCartModal","reservedQty")}
                                </div>
                                <div className="header-col" style={{flex: "1"}}>
                                    {localization.text("order","shoppingCartModal","sumPrice")}
                                </div>
                            </div>
                            <Scroll style={{height: 500, width:"100%", opacity:undefined}}>
                                { activeOrder.loading ? (
                                    <Loading height={500} width="100%" loadingSize={9} points={12} lapTime={2}/>
                                ) : (
                                    this.prepareLines()
                                )}
                            </Scroll>
                        </div>
                    </div>
                    <div className="footer">
                        <div className="shopping-cart-menu-info">
                            <Icon type={iconTypes.boxOpen} style={{marginLeft:"9px"}}/>
                            <div className="label16 shopping-cart-menu-info-text flex-align-center">
                                {localization.text("order","inYourOrder")}
                            </div>
                            {hasWarningLines() && (
                                <div className="tooltip">
                                    <Icon type={iconTypes.warning} />
                                    <span className="tooltiptext" style={{width:"180px",marginLeft:"-90px"}}>{localization.text("order","warningTooltip")}</span>
                                </div>
                            )}
                            {hasErrorLines() && (
                                <div className="tooltip">
                                    <Icon type={iconTypes.error} />
                                    <span className="tooltiptext" style={{width:"180px",marginLeft:"-90px"}}>{localization.text("order","errorTooltip")}</span>
                                </div>
                            )}
                            <div className="flex-align-center">
                                { orderSize>0 ? (
                                    <Tag type={tagTypes.red} label={localization.text("order","countLines",{count:orderSize})}/>
                                ) : (
                                    <Tag type={tagTypes.grey} label={localization.text("order","empty")} className={"tag-large"}/>
                                )}
                            </div>
                        </div>
                        <ResponsiveRows>
                            <ResponsiveColumn xs={4} sm={2}>
                                <div className="shopping-cart-info-header">
                                    {localization.text("order", "deliveryFee")}
                                </div>
                                <div className="shopping-cart-info-price">{orderFeeOrDiscount.toFixed(2)}</div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={4}>
                                <div className="shopping-cart-info-header-bold">
                                    {localization.text("order", "feeBase")}
                                </div>
                                <div className="shopping-cart-info-price-bold">{baseAmountOrderFee.toFixed(2)}</div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={4}>
                                <div className="shopping-cart-info-header-bold">
                                    {localization.text("order", "total")}
                                </div>
                                <div className="shopping-cart-info-price-bold">{totalCost.toFixed(2)}</div>
                            </ResponsiveColumn>
                        </ResponsiveRows>
                    </div>
                </div>
            </Modal>
        );
    }
}

ShoppingCartDetailsModal.propTypes = {
    localization: Localization.propTypes.isRequired,
    activeOrder: PropTypes.object.isRequired,
    width: PropTypes.number,
    setActiveOrder: PropTypes.func.isRequired,
    onCloseModal: PropTypes.func.isRequired,
    hasWarningLines: PropTypes.func.isRequired,
    hasErrorLines: PropTypes.func.isRequired,
    showShoppingCartPdf: PropTypes.func.isRequired,
    token: PropTypes.string.isRequired,
};

export default  withRouter(connect(mapStateToProps)(ShoppingCartDetailsModal));
